import PageBreadcrumb from "../../components/common/CustomBreadCrumb";
import PageMeta from "../../components/common/PageMeta";
import ComponentCard from "../../components/common/ComponentCard";
import TextArea from "../../components/form/input/TextArea";
import { useEffect, useState } from "react";
import useGoBack from "../../hooks/useGoBack";
import UserService from "../../services/user.service";
import { toast } from "react-toastify";
import { useParams } from "react-router";
import Label from "@/components/form/Label";
import Input from "@/components/form/input/InputField";
import { parseISO, format } from "date-fns";
import { useTranslation } from "react-i18next";

export default function ViewUser() {
    const { t } = useTranslation();
    const { user_id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [userData, setUserData] = useState({
        full_name: "",
        email_address: "",
        phone_number: "",
        created_at: "",
        last_study_date: "",
        total_cards_created: 0
    });

    const goBack = useGoBack();

    const fetchDeck = async () => {
        try {
            const response = await UserService.getUserById(user_id || "");
            console.log("response", response);

            if (response?.data?.status === 200) {
                setUserData({
                    full_name: response?.data?.data?.user?.full_name,
                    email_address: response?.data?.data?.user?.email_address,
                    phone_number: response?.data?.data?.user?.phone_number,
                    created_at: format(parseISO(response?.data?.data?.user?.createdAt), "MM/dd/yyyy hh:mm a"),
                    last_study_date: format(parseISO(response?.data?.data?.user?.streak?.lastStudyDate), "MM/dd/yyyy hh:mm a"),
                    total_cards_created: response?.data?.data?.deck?.deckCreated.length
                })
            }
        } catch (err) {
            console.error("Error fetching decks:", err);
        }
    };

    useEffect(() => {
        fetchDeck()
    }, []);

    return (
        <div>
            <PageMeta
                title="VIYUME - VIYUME Dashboard"
                description={t("View User")}
            />
            <div className="mx-auto max-w-[80%] grid grid-cols-1 gap-6">
                <div className="space-y-6">
                    <ComponentCard title="">
                        <div className="space-y-6">
                            <div>
                                <Label>{t("Full Name")}</Label>
                                <Input
                                    type="text"
                                    value={userData.full_name}
                                    placeholder={t("Full Name")}
                                    disabled={isLoading}
                                />
                            </div>
                            <div>
                                <Label>{t("Email Address")}</Label>
                                <Input
                                    type="email"
                                    value={userData.email_address}
                                    placeholder={t("Email Address")}
                                    disabled={isLoading}
                                />
                            </div>
                            <div>
                                <Label>{t("Phone Number")}</Label>
                                <Input
                                    type="text"
                                    value={userData.phone_number}
                                    placeholder={t("Phone Number")}
                                    disabled={isLoading}
                                />
                            </div>
                            <div>
                                <Label>{t("Created At")}</Label>
                                <Input
                                    type="text"
                                    value={userData.created_at}
                                    placeholder={t("Created At")}
                                    disabled={isLoading}
                                />
                            </div>
                            <div>
                                <Label>{t("Last Study Date")}</Label>
                                <Input
                                    type="text"
                                    value={userData.last_study_date}
                                    placeholder={t("Last Study Date")}
                                    disabled={isLoading}
                                />
                            </div>
                            <div>
                                <Label>{t("Total Cards Created")}</Label>
                                <Input
                                    type="text"
                                    value={userData.total_cards_created}
                                    placeholder={t("Total Cards Created")}
                                    disabled={isLoading}
                                />
                            </div>
                        </div>
                    </ComponentCard>
                </div>
            </div>
        </div>
    );
}
